import React from 'react';
import { ButtonGroup } from 'reactstrap';
import Button from 'components/Core/Button/index';
import IntlMessages from 'util/IntlMessages';
import ClientRequestService from 'services/ClientRequestService';
import 'react-notifications/lib/notifications.css';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Finder from 'components/Finder/index';

import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader';

const ModelState = {
  Added: 'Added',
  Modified: 'Modified',
  Deleted: 'Deleted',
  Unchanged: 'Unchanged',
  Detached: 'Detached',
  Archived: 'Archived'
};

class BaseComponent extends React.Component {
  constructor(props) {
    super(props);

    this.baseProps = {
      ModelState: ModelState.Unchanged,
      RowVersion: 0
    };

    this.buttonPrivileges = {
      ...{
        showNew: true,
        showSearch: true,
        showClear: true,
        showDelete: true,
        showCreate: true,
        showUpdate: true
      },
      ...this.props.buttonPrivileges
    };

    this.state = {
      ...this.baseProps,
      showFinder: false,
      showLoader: false,
      mountLocalizedComponents: false,
      buttonPrivileges: { ...this.buttonPrivileges }
    };

    this.dataHandlerService = new ClientRequestService(
      this.props.module ? this.props.module : 'SHOMOSHTEE'
    );

    this.saveSuccessMsg = React.createRef();
    this.loadSuccessMsg = React.createRef();
    this.deleteSuccessMsg = React.createRef();
    this.modelNotLoadedWarningMsg = React.createRef();

    this.successMsgHeader = React.createRef();
    this.infoMsgHeader = React.createRef();
    this.warningMsgHeader = React.createRef();
    this.errorMsgHeader = React.createRef();

    this.confirmMsgHeader = React.createRef();
    this.confirmMsg = React.createRef();
    this.msgDialogHeader = React.createRef();
    this.msgDialog = React.createRef();
    this.confirmDeleteMsgHeader = React.createRef();
    this.confirmDeleteMsg = React.createRef();

    this.labelName = React.createRef();
    this.labelDepartment = React.createRef();
    this.labelSequenceNo = React.createRef();
    this.labelCode = React.createRef();
    this.labelShortName = React.createRef();
    this.labelActive = React.createRef();
    this.labelPrefix = React.createRef();

    this.labelButtonClear = React.createRef();
    this.labelButtonDelete = React.createRef();
    this.labelButtonUpdate = React.createRef();
    this.labelButtonSearch = React.createRef();
    this.labelButtonSave = React.createRef();
    this.labelButtonCreate = React.createRef();
    this.labelButtonNew = React.createRef();
    this.labelButtonYes = React.createRef();
    this.labelButtonNo = React.createRef();
    this.labelButtonOK = React.createRef();
    this.labelButtonCancel = React.createRef();
  }

  componentDidMount() {

    //Remove all notification or error message
    this.dataHandlerService.util.hideNotificationMsg();

    this.commonNotifications = {
      saveSuccess: this.saveSuccessMsg.current.innerText,
      loadSuccess: this.loadSuccessMsg.current.innerText,
      deleteSuccess: this.deleteSuccessMsg.current.innerText,
      modelNotLoadedWarning: this.modelNotLoadedWarningMsg.current.innerText,
      confirmMsg: this.confirmMsg.current.innerText,
      msgDialog: this.msgDialog.current.innerText,
      successHeader: this.successMsgHeader.current.innerText,
      infoHeader: this.infoMsgHeader.current.innerText,
      warningHeader: this.warningMsgHeader.current.innerText,
      errorHeader: this.errorMsgHeader.current.innerText,
      confirmMsgHeader: this.confirmMsgHeader.current.innerText,
      msgDialogHeader: this.msgDialogHeader.current.innerText,
      confirmDeleteMsgHeader: this.confirmDeleteMsgHeader.current.innerText,
      confirmDeleteMsg: this.confirmDeleteMsg.current.innerText
    };

    this.commonLabels = {
      name: this.labelName.current.innerText,
      department: this.labelDepartment.current.innerText,
      sequenceNo: this.labelSequenceNo.current.innerText,
      code: this.labelCode.current.innerText,
      shortName: this.labelShortName.current.innerText,
      active: this.labelActive.current.innerText,
      prefix: this.labelPrefix.current.innerText,
      buttonClear: this.labelButtonClear.current.innerText,
      buttonDelete: this.labelButtonDelete.current.innerText,
      buttonUpdate: this.labelButtonUpdate.current.innerText,
      buttonSearch: this.labelButtonSearch.current.innerText,
      buttonSave: this.labelButtonSave.current.innerText,
      buttonCreate: this.labelButtonCreate.current.innerText,
      buttonNew: this.labelButtonNew.current.innerText,
      buttonYes: this.labelButtonYes.current.innerText,
      buttonNo: this.labelButtonNo.current.innerText,
      buttonOK: this.labelButtonOK.current.innerText,
      buttonCancel: this.labelButtonCancel.current.innerText
    };

    this.confirmDialogStates = {
      openConfirmDialog: false,
      confirmDialogTitle: this.commonNotifications['confirmMsgHeader'],
      confirmDialogContentText: this.commonNotifications['confirmMsg']
    };

    this.messageDialogStates = {
      openMessageDialog: false,
      messageDialogTitle: this.commonNotifications['msgDialogHeader'],
      messageDialogContentText: this.commonNotifications['msgDialog']
    };

    this.setState({
      ...this.messageDialogStates,
      ...this.confirmDialogStates,
      mountLocalizedComponents: true
    });
  }

  ShowWait() {
    this.setState({ showLoader: true });
  }

  HideWait() {
    this.setState({ showLoader: false });
  }

  closeMessageDialog = () => {
    this.setState({ ...this.messageDialogStates });
  };

  openMessageDialog = (title, body, onMsgDialogOKClick) => {
    this.setState({
      ...this.messageDialogStates,
      openMessageDialog: true,
      messageDialogTitle: title ? title : this.state.messageDialogTitle,
      messageDialogContentText: body
        ? body
        : this.state.messageDialogContentText,
      onMsgDialogOKClick: onMsgDialogOKClick
        ? onMsgDialogOKClick
        : this.closeMessageDialog
    });
  };

  closeConfirmDialog = () => {
    this.setState({ ...this.confirmDialogStates });
  };

  openConfirmDialog = (
    title,
    body,
    onConfirmDialogYesClick,
    onConfirmDialogNoClick
  ) => {
    this.setState({
      ...this.confirmDialogStates,
      openConfirmDialog: true,
      confirmDialogTitle: title ? title : this.state.confirmDialogTitle,
      confirmDialogContentText: body
        ? body
        : this.state.confirmDialogContentText,
      onConfirmDialogYesClick: onConfirmDialogYesClick
        ? onConfirmDialogYesClick
        : this.closeConfirmDialog,
      onConfirmDialogNoClick: onConfirmDialogNoClick
        ? onConfirmDialogNoClick
        : this.closeConfirmDialog
    });
  };

  showSaveSuccess() {
    this.dataHandlerService.util.showNotificationMsg(
      this.commonNotifications['saveSuccess'],
      'success'
    );
  }

  showLoadSuccess() {
    this.dataHandlerService.util.showNotificationMsg(
      this.commonNotifications['loadSuccess'],
      'success'
    );
  }

  showDeleteSuccess() {
    this.dataHandlerService.util.showNotificationMsg(
      this.commonNotifications['deleteSuccess'],
      'success'
    );
    this.closeConfirmDialog();
  }

  showModelNotLoadedWarning() {
    this.dataHandlerService.util.showNotificationMsg(
      this.commonNotifications['modelNotLoadedWarning'],
      'warning'
    );
  }

  setButtonPrivileges = buttonPrivileges => {
    this.setState({
      buttonPrivileges: { ...this.state.buttonPrivileges, ...buttonPrivileges }
    });
  };

  setModel = (model, completedAction = 'save') => {
    const { ModelState, RowVersion } = model;

    this.setState({ ModelState, RowVersion }, () => {
      switch (completedAction) {
        case 'save':
          this.showSaveSuccess();
          break;
        case 'load':
          this.showLoadSuccess();
          break;
        case 'delete':
          this.showDeleteSuccess();
          break;
        default:
          this.showSaveSuccess();
          break;
      }
    });
  };

  setModelState = (keyProp, modelState) => {
    return new Promise(resolve => {
      this.setState(
        {
          ModelState: modelState
            ? modelState
            : !keyProp || keyProp === 0
              ? ModelState.Added
              : ModelState.Modified
        },
        () => resolve()
      );
    });
  };

  save = (
    parent,
    url,
    withModule,
    additionalDataModel,
    beforeSave,
    afterSave
  ) => {
    if (!this.props.isValidForm) return;

    parent.setState({ stateToFormData: true });
    let keyModel = parent.state[parent.state.keyModel];

    parent.baseComponent.current
      .setModelState(
        keyModel ? keyModel[parent.state.keyProp] : null,
        parent.baseComponent.current.state.ModelState === ModelState.Added
          ? ModelState.Added
          : null
      )
      .then(() => {
        const { ModelState, RowVersion } = parent.baseComponent.current.state;
        keyModel = { ...keyModel, ModelState, RowVersion };

        let postData = additionalDataModel
          ? { ...additionalDataModel, [parent.state.keyModel]: keyModel }
          : keyModel;

        if (typeof (beforeSave) === 'function') {
          var processedData;
          Promise.resolve(beforeSave(postData)).then(
            (data) => {
              processedData = data;

              if (processedData === false) {
                return false;
              }

              postData = processedData ? processedData : postData;
              this.saveModel(parent, url, withModule, postData, afterSave);
            }
          );
        } else {
          this.saveModel(parent, url, withModule, postData, afterSave);
        }
      });
  };

  saveModel = (parent, url, withModule, postData, afterSave) => {
    let method = 'Post';
    if (parent.baseComponent.current.state.ModelState === ModelState.Modified)
      method = 'Put';
    const headers = {
      menuprivilege: JSON.stringify(this.props.privileges || {}),
      menuparameter: this.props.parameters
    };
    this.ShowWait();
    this.dataHandlerService[method]({
      url,
      withModule,
      data: postData,
      headers
    }).then(viewModel => {
      this.HideWait();
      if (viewModel) {
        let modelData = viewModel.hasOwnProperty(parent.state.keyModel)
          ? viewModel[parent.state.keyModel]
          : viewModel;
        parent.setState({ [parent.state.keyModel]: { ...parent.state[parent.state.keyModel], ...modelData } });

        parent.baseComponent.current.setModel(modelData);
        parent.baseComponent.current.setModelState(
          modelData[parent.state.keyProp]
        );

        if (parent.minifinder) {
          parent.minifinder.minifinder.refreshTable();
        }

        if (parent.state.stateToFormData) {
          parent.setState({ stateToFormData: false });
        }

        parent.setState({ isValidForm: true });

        if (afterSave) {
          afterSave(viewModel);
        }
      }
    });
  };

  load = (
    parent,
    controller,
    action,
    params,
    additionalDataModel,
    beforeLoad,
    afterload,
    finderRef
  ) => {
    parent.setState({ stateToFormData: true });
    let doesNotContainAdditionalDataModel = !additionalDataModel;

    let postData = additionalDataModel
      ? { ...additionalDataModel, ...params }
      : params;

    if (typeof (beforeLoad) === 'function') {
      let processedData = beforeLoad(postData);
      if (processedData === false) return false;
      postData = processedData ? processedData : postData;
      this.loadModel(
        parent,
        controller,
        action,
        postData,
        afterload,
        doesNotContainAdditionalDataModel,
        finderRef
      );
    } else {
      this.loadModel(
        parent,
        controller,
        action,
        postData,
        afterload,
        doesNotContainAdditionalDataModel,
        finderRef
      );
    }
  };

  loadModel = (
    parent,
    controller,
    action,
    postData,
    afterload,
    doesNotContainAdditionalDataModel,
    finderRef
  ) => {
    let method = 'Post';
    if (doesNotContainAdditionalDataModel) method = 'Get';
    const headers = {
      menuprivilege: JSON.stringify(this.props.privileges || {}),
      menuparameter: this.props.parameters
    };

    this.dataHandlerService[method]({
      url: `${controller}/${action}`,
      withModule: false,
      data: postData,
      headers
    })
      .then(viewModel => {
        if (viewModel) {
          let modelData = viewModel.hasOwnProperty(parent.state.keyModel)
            ? viewModel[parent.state.keyModel]
            : viewModel;
          parent.setState({ [parent.state.keyModel]: { ...parent.state[parent.state.keyModel], ...modelData } });

          parent.baseComponent.current.setModel(modelData, 'load');
          parent.baseComponent.current.setModelState(
            modelData[parent.state.keyProp]
          );

          if (finderRef) {
            finderRef.closeMessageDialog();
          }

          if (parent.state.stateToFormData) {
            parent.setState({ stateToFormData: false });
          }

          parent.setState({ isValidForm: true });

          if (afterload) {
            afterload(viewModel);
          }
        }
      })
      .catch(error => this.HideWait());;
  };

  delete = (
    parent,
    url,
    withModule,
    additionalDataModel,
    beforeDelete,
    afterDelete
  ) => {
    if (!this.props.isValidForm) return;

    const keyModel = parent.state[parent.state.keyModel];
    const modelExists = keyModel
      ? keyModel[parent.state.keyProp] !== null &&
        keyModel[parent.state.keyProp] !== 0
        ? true
        : false
      : false;

    if (!modelExists) {
      this.showModelNotLoadedWarning();
      return;
    }

    this.openConfirmDialog(
      this.commonNotifications['confirmDeleteMsgHeader'],
      this.commonNotifications['confirmDeleteMsg'],
      this.prepareDeleteModel.bind(
        null,
        parent,
        url,
        withModule,
        additionalDataModel,
        beforeDelete,
        afterDelete
      )
    );
  };

  prepareDeleteModel = (
    parent,
    url,
    withModule,
    additionalDataModel,
    beforeDelete,
    afterDelete
  ) => {
    let keyModel = parent.state[parent.state.keyModel];

    parent.baseComponent.current
      .setModelState(keyModel[parent.state.keyProp], ModelState.Deleted)
      .then(() => {
        keyModel = { ...keyModel, ...parent.baseComponent.current.state };
        let postData = additionalDataModel
          ? { ...additionalDataModel, [parent.state.keyModel]: keyModel }
          : keyModel;

        if (typeof (beforeDelete) === 'function') {
          var processedData;
          Promise.resolve(beforeDelete(postData)).then(
            (data) => {
              processedData = data;

              if (processedData === false) {
                parent.baseComponent.current.setState({ openConfirmDialog: false, ModelState: ModelState.Modified });
                return false;
              }

              postData = processedData ? processedData : postData;
              this.deleteModel(parent, url, withModule, postData, afterDelete);
            }
          );
        } else {
          this.deleteModel(parent, url, withModule, postData, afterDelete);
        }
      });
  };

  deleteModel = (parent, url, withModule, postData, afterDelete) => {
    const headers = {
      menuprivilege: JSON.stringify(this.props.privileges || {}),
      menuparameter: this.props.parameters
    };
    this.ShowWait();
    this.dataHandlerService
      .Delete({ url, withModule, data: postData, headers })
      .then(res => {
        this.HideWait();
        if (res && res.data && res.data.ResponseCode === 'DELETED') {
          this.showDeleteSuccess();
          parent.actionMethods.clear();

          if (typeof (afterDelete) === 'function') {
            afterDelete(res.data.Result);
          }

          if (parent.minifinder) {
            parent.minifinder.minifinder.refreshTable();
          }
        }
      })
      .catch(error => { this.HideWait(); this.closeConfirmDialog(); });
  };

  clear = (parent, beforeClear, afterClear) => {
    const keyModel = parent[parent.state.keyModel];

    if (beforeClear) {
      beforeClear();
    }

    parent.setState({ [parent.state.keyModel]: keyModel, clear: true });

    parent.baseComponent.current.setState({
      ...parent.baseComponent.current.baseProps,
      mountLocalizedComponents: true
    });
    parent.baseComponent.current.setModelState(keyModel[parent.state.keyProp]);

    if (parent.state.stateToFormData) {
      parent.setState({ stateToFormData: false });
    }

    if (afterClear) {
      afterClear();
    }
  };

  new = (parent, beforeNew, afterNew) => {
    const keyModel = parent[parent.state.keyModel];

    if (beforeNew) {
      beforeNew();
    }

    parent.setState({ [parent.state.keyModel]: keyModel, clear: true });

    parent.baseComponent.current.setState({
      ...parent.baseComponent.current.baseProps,
      mountLocalizedComponents: true
    });
    parent.baseComponent.current.setModelState(null, ModelState.Added);

    if (parent.state.stateToFormData) {
      parent.setState({ stateToFormData: false });
    }

    if (afterNew) {
      afterNew();
    }
  };

  search = searchSettings => {
    if (searchSettings.finderConfig.template) {
      if (!searchSettings.finderConfig.filters) {
        searchSettings.finderConfig.filters = {};
      }

      searchSettings.finderConfig.template
        .filter(col => col.filter)
        .forEach(col => {
          searchSettings.finderConfig.filters[col.field] = { value: '' };
        });
    }

    this.finder = <Finder {...searchSettings} />;
    this.setState({ showFinder: true });
  };

  render() {
    const { privileges } = this.props;

    let actionMethods = { ...this.props.actionMethods };
    let hiddenDiv = (
      <div className='d-none'>
        <label ref={this.saveSuccessMsg}>
          <IntlMessages id='appNotification.saveSuccessMessage' />
        </label>
        <label ref={this.loadSuccessMsg}>
          <IntlMessages id='appNotification.loadSuccessMessage' />
        </label>
        <label ref={this.deleteSuccessMsg}>
          <IntlMessages id='appNotification.deleteSuccessMessage' />
        </label>
        <label ref={this.modelNotLoadedWarningMsg}>
          <IntlMessages id='appNotification.modelNotLoadedWarningMessage' />
        </label>
        <label ref={this.successMsgHeader}>
          <IntlMessages id='notification.success' />
        </label>
        <label ref={this.infoMsgHeader}>
          <IntlMessages id='notification.info' />
        </label>
        <label ref={this.warningMsgHeader}>
          <IntlMessages id='notification.warning' />
        </label>
        <label ref={this.errorMsgHeader}>
          <IntlMessages id='notification.error' />
        </label>

        <label ref={this.msgDialogHeader}>
          <IntlMessages id='sweetAlerts.prompt' />
        </label>
        <label ref={this.msgDialog}>
          <IntlMessages id='sweetAlerts.hereIsaMessage' />
        </label>
        <label ref={this.confirmMsgHeader}>
          <IntlMessages id='sweetAlerts.areYouSureHeader' />
        </label>
        <label ref={this.confirmMsg}>
          <IntlMessages id='sweetAlerts.areYouSure' />
        </label>
        <label ref={this.confirmDeleteMsgHeader}>
          <IntlMessages id='sweetAlerts.areYouSureDeleteHeader' />
        </label>
        <label ref={this.confirmDeleteMsg}>
          <IntlMessages id='sweetAlerts.areYouSureDelete' />
        </label>

        <label ref={this.labelName}>
          <IntlMessages id='label.name' />
        </label>
        <label ref={this.labelDepartment}>
          <IntlMessages id='label.department' />
        </label>
        <label ref={this.labelSequenceNo}>
          <IntlMessages id='label.sequenceNo' />
        </label>
        <label ref={this.labelCode}>
          <IntlMessages id='label.code' />
        </label>
        <label ref={this.labelShortName}>
          <IntlMessages id='label.shortName' />
        </label>
        <label ref={this.labelActive}>
          <IntlMessages id='label.active' />
        </label>
        <label ref={this.labelPrefix}>
          <IntlMessages id='label.prefix' />
        </label>

        <label ref={this.labelButtonClear}>
          <IntlMessages id='button.clear' />
        </label>
        <label ref={this.labelButtonDelete}>
          <IntlMessages id='button.delete' />
        </label>
        <label ref={this.labelButtonUpdate}>
          <IntlMessages id='button.update' />
        </label>
        <label ref={this.labelButtonSearch}>
          <IntlMessages id='button.search' />
        </label>
        <label ref={this.labelButtonSave}>
          <IntlMessages id='button.save' />
        </label>
        <label ref={this.labelButtonCreate}>
          <IntlMessages id='button.create' />
        </label>
        <label ref={this.labelButtonNew}>
          <IntlMessages id='button.new' />
        </label>
        <label ref={this.labelButtonYes}>
          <IntlMessages id='button.yes' />
        </label>
        <label ref={this.labelButtonNo}>
          <IntlMessages id='button.no' />
        </label>
        <label ref={this.labelButtonOK}>
          <IntlMessages id='button.ok' />
        </label>
        <label ref={this.labelButtonCancel}>
          <IntlMessages id='button.cancel' />
        </label>
      </div>
    );

    // new, create/update, search, clear, delete

    let clearAtRightMost = !this.state.buttonPrivileges.showDelete;
    let searchAtRightMost = !this.state.buttonPrivileges.showDelete && !this.state.buttonPrivileges.showClear;
    let createAtRightMost = !this.state.buttonPrivileges.showDelete && !this.state.buttonPrivileges.showClear && !this.state.buttonPrivileges.showSearch;
    let updateAtRightMost = createAtRightMost;
    let newAtRightMost = !this.state.buttonPrivileges.showDelete && !this.state.buttonPrivileges.showClear && !this.state.buttonPrivileges.showSearch && !this.state.buttonPrivileges.showCreate && !this.state.buttonPrivileges.showUpdate;

    return privileges.CanRead ||
      privileges.CanDelete ||
      privileges.CanUpdate ||
      privileges.CanCreate ? (
      <div className='page-footer MuiPaper-elevation4 col-lg-12 d-xs-flex d-sm-flex d-md-flex d-lg-flex justify-content-sm-end align-items-sm-end justify-content-md-end align-items-md-end justify-content-lg-end align-items-lg-end'>
        {hiddenDiv}

        {
          this.state.mountLocalizedComponents &&
          (
            <Dialog open={this.state.openMessageDialog} fullWidth>
              <DialogTitle>{this.state.messageDialogTitle}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {this.state.messageDialogContentText}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  label={this.commonLabels['buttonOK']}
                  style={{ margin: '0 10px 0 0' }}
                  onClick={this.state.onMsgDialogOKClick}
                ></Button>
              </DialogActions>
            </Dialog>
          )
        }

        {
          this.state.mountLocalizedComponents &&
          (
            <Dialog open={this.state.openConfirmDialog} fullWidth>
              <DialogTitle>{this.state.confirmDialogTitle}</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {this.state.confirmDialogContentText}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  label={this.commonLabels['buttonNo']}
                  style={{ margin: '0 10px 0 0' }}
                  onClick={this.state.onConfirmDialogNoClick}
                ></Button>
                <Button
                  label={this.commonLabels['buttonYes']}
                  style={{ margin: '0 10px 0 0' }}
                  onClick={this.state.onConfirmDialogYesClick}
                ></Button>
              </DialogActions>
            </Dialog>
          )
        }

        {
          this.state.showFinder &&
          this.finder
        }

        {
          this.state.mountLocalizedComponents && (
            <LoadingOverlay
              active={this.state.showLoader}
              spinner={<BounceLoader size={20} color={"#0F94F1"} />}
              styles={{
                overlay: (base) => ({
                  ...base,
                  background: 'rgba(244, 244, 244, 0.6)'
                })
              }}>
              <ButtonGroup vertical={false}>
                {
                  privileges.CanRead &&
                  this.state.buttonPrivileges.showPrint && (
                    <Button
                      className={`action-button bg-info ${searchAtRightMost ? 'rightmost-button' : ''}`}
                      label='Print'
                      icon='pi pi-print'
                      onClick={actionMethods.print}
                    />
                  )
                }
                {
                  privileges.CanCreate &&
                  this.state.buttonPrivileges.showNew && (
                    <Button
                      className={`action-button ${newAtRightMost ? 'rightmost-button' : ''}`}
                      label={this.commonLabels['buttonNew']}
                      icon='pi pi-plus'
                      onClick={actionMethods.new}
                    />
                  )
                }
                {
                  privileges.CanCreate &&
                  this.state.buttonPrivileges.showCreate &&
                  this.state.ModelState === ModelState.Added && (
                    <Button
                      className={`action-button bg-success ${createAtRightMost ? 'rightmost-button' : ''}`}
                      style={createAtRightMost ? { marginRight: '45px !important' } : {}}
                      label={this.commonLabels['buttonCreate']}
                      icon='pi pi-save'
                      onClick={actionMethods.save}
                      disabled={!this.props.isValidForm}
                    />
                  )
                }
                {
                  privileges.CanUpdate &&
                  this.state.buttonPrivileges.showUpdate &&
                  this.state.ModelState === ModelState.Modified && (
                    <Button
                      className={`action-button bg-success ${updateAtRightMost ? 'rightmost-button' : ''}`}
                      label={this.commonLabels['buttonUpdate']}
                      icon='pi pi-check'
                      onClick={actionMethods.update}
                      disabled={!this.props.isValidForm}
                    />
                  )
                }
                {
                  privileges.CanRead &&
                  this.state.buttonPrivileges.showSearch && (
                    <Button
                      className={`action-button bg-info ${searchAtRightMost ? 'rightmost-button' : ''}`}
                      label={this.commonLabels['buttonSearch']}
                      icon='pi pi-search'
                      onClick={actionMethods.search}
                    />
                  )
                }
                {
                  privileges.CanRead &&
                  this.state.buttonPrivileges.showClear && (
                    <Button
                      className={`action-button bg-warning ${clearAtRightMost ? 'rightmost-button' : ''}`}
                      label={this.commonLabels['buttonClear']}
                      icon='pi pi-times'
                      onClick={actionMethods.clear}
                    />
                  )
                }
                {
                  privileges.CanDelete &&
                  this.state.buttonPrivileges.showDelete && (
                    <Button
                      className='action-button rightmost-button bg-danger'
                      label={this.commonLabels['buttonDelete']}
                      icon='pi pi-trash'
                      onClick={actionMethods.delete}
                      disabled={!this.props.isValidForm}
                    />
                  )
                }
              </ButtonGroup>
            </LoadingOverlay>
          )
        }
      </div>
    ) : (
      <div>{hiddenDiv}</div>
    );

  }
}

export default BaseComponent;
